import { Link, NavLink } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
import { LogOut, Shield, Sparkles } from 'lucide-react'

export default function AppShell({ children }) {
  const { user, logout } = useAuth()

  return (
    <div className="min-h-screen bg-slate-50">
      <header className="sticky top-0 z-50 h-14 bg-white border-b border-gray-200 shadow-sm">
        <div className="max-w-7xl mx-auto h-full px-4 flex items-center justify-between">
          <div className="flex items-center gap-4 sm:gap-6">
            <Link to="/" className="flex items-center gap-2 text-gray-900 hover:text-blue-600 transition-colors">
              <span className="text-xl">🎓</span>
              <span className="font-semibold text-sm">Finder University</span>
            </Link>
          </div>

          {user && (
            <div className="flex items-center gap-3">
              {(user.isAdmin || user.isManager) && (
                <Link
                  to="/admin"
                  className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-md text-xs font-medium transition-colors ${
                    user.isAdmin
                      ? 'text-purple-700 bg-purple-50 hover:bg-purple-100'
                      : 'text-blue-700 bg-blue-50 hover:bg-blue-100'
                  }`}
                >
                  <Shield className="w-3.5 h-3.5" />
                  {user.isAdmin ? 'Admin' : 'Dashboard'}
                </Link>
              )}

              <div className="flex items-center gap-2">
                {user.photoURL ? (
                  <img
                    src={user.photoURL}
                    alt={user.displayName}
                    className="w-7 h-7 rounded-full border border-gray-200"
                    referrerPolicy="no-referrer"
                  />
                ) : (
                  <div className="w-7 h-7 rounded-full bg-blue-100 flex items-center justify-center text-xs font-medium text-blue-700">
                    {user.displayName?.charAt(0) || user.email?.charAt(0) || '?'}
                  </div>
                )}
                <span className="text-sm text-gray-700 hidden sm:block">
                  {user.displayName?.split(' ')[0]}
                </span>
              </div>

              <button
                onClick={logout}
                className="p-1.5 rounded-md text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition-colors"
                title="Sign out"
              >
                <LogOut className="w-4 h-4" />
              </button>
            </div>
          )}
        </div>
      </header>

      <main>{children}</main>
    </div>
  )
}
